// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f2d63486219fa9834f20339f145dde9772884fd8.chunk.js";
};